<template>
  <span :class="['tag', type && `tag-${type}`]">
    <slot></slot>
    <lp-icon v-if="closable" name="close" class="tag-close" @click="close" />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Colors } from '../../models/enums'

export default defineComponent({
  name: 'lp-tag',
  props: {
    type: {
      default: Colors.NEUTRAL,
    },
    closable: { type: Boolean },
  },
  emits: ['close'],
  setup(props, { emit }) {
    function close() {
      if (!props.closable) {
        return
      }
      emit('close')
    }

    return { close }
  },
})
</script>
